import { render, staticRenderFns } from "./PowerData.vue?vue&type=template&id=06bcccdd&scoped=true&"
import script from "./PowerData.vue?vue&type=script&lang=js&"
export * from "./PowerData.vue?vue&type=script&lang=js&"
import style0 from "./PowerData.vue?vue&type=style&index=0&id=06bcccdd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bcccdd",
  null
  
)

export default component.exports